import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { select, Store } from '@ngrx/store'
import {
  selectRentalSmartDevices,
  SmartDevice,
  SmartDeviceAccess,
  SmartDeviceAccessService,
  SmartDeviceAccount,
  SmartDeviceService,
  SmartDevicesGuard,
  SmartDeviceSettingsGuard,
} from '@tokeet-frontend/smart-devices'
import { DataCheckerService, Destroyable, DialogService, untilDestroy } from '@tokeet-frontend/tv3-platform'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import * as lodash from 'lodash'
import { finalize } from 'rxjs/operators'

import { NewAccesscodeDialogComponent } from '../new-accesscode-dialog/new-accesscode-dialog.component'
import { SmartDevicesSubscribeService } from '../smart-devices-subscribe.service'
import { AmplitudeService } from '@tv3/services/amplitude.service'

@Component({
  selector: 'app-booking-access-code',
  templateUrl: './booking-access-code.component.html',
  styleUrls: ['./booking-access-code.component.scss'],
})
export class BookingAccessCodeComponent extends Destroyable implements OnInit {
  @Input() inquiry: Inquiry
  @Input() tile = false

  @Output() link = new EventEmitter()

  isLoading = true
  codesByDeviceId: Record<string, SmartDeviceAccess> = {}
  devices: SmartDevice[] = []
  accountById: Record<string, SmartDeviceAccount> = {}
  constructor(
    private store: Store<any>,
    private accessService: SmartDeviceAccessService,
    private smartDeviceService: SmartDeviceService,
    private dialog: DialogService,
    private subscribeDeviceService: SmartDevicesSubscribeService,
    private dataChecker: DataCheckerService,
    private amplitudeService: AmplitudeService
  ) {
    super()
    this.dataChecker.check([SmartDevicesGuard, SmartDeviceSettingsGuard])
  }

  ngOnInit(): void {
    this.store.pipe(select(selectRentalSmartDevices(this.inquiry.rentalId)), untilDestroy(this)).subscribe((items) => {
      this.devices = items
    })

    this.smartDeviceService
      .accounts()
      .pipe(untilDestroy(this))
      .subscribe((accounts) => {
        this.accountById = accounts.reduce((acc, account) => {
          acc[account.connectedAccountId] = account
          return acc
        }, {} as Record<string, SmartDeviceAccount>)
      })

    this.refresh()
  }

  refresh() {
    this.isLoading = true

    this.accessService
      .getBookingDeviceAccesses(this.inquiry.id)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(
        (data) => {
          this.codesByDeviceId = lodash.mapValues(
            lodash.groupBy(data, (c) => c.device_id),
            (codes) => lodash.head(codes)
          )
        },
        (error) => {
          // this.store.dispatch(ActionFailed({ error }))
        }
      )
  }

  get isCanceled() {
    return !!this.inquiry?.canceled
  }

  isDeviceDisconnected(device: SmartDevice) {
    return this.accountById[device.connectedAccountId]?.connected === false
  }

  onNewCode(device: SmartDevice) {
    if (this.isCanceled || this.isDeviceDisconnected(device)) {
      return
    }

    if (!this.subscribeDeviceService.checkSubscription()) {
      return
    }
    this.amplitudeService.logEvent('smart-devices-booking-new-code')

    this.dialog
      .openFixedDialog(NewAccesscodeDialogComponent, {
        width: '600px',
        data: { inquiry: this.inquiry, device },
      })
      .afterClosed()
      .subscribe(() => {
        this.refresh()
      })
  }
}
